module.exports = __webpack_public_path__ + "static/media/pie-chart.8505b4e3.svg";